module.exports = __webpack_public_path__ + "static/image/history/pc/202606_1.ver2_0_2.jpg?fab5b2d7";